import { MuWidget } from "mu-widget/lib/MuWidget";
import { CForms } from "../Generated/CClasses";
import { LoginData } from "../Types";
import { VVZLogin } from "./VVZLogin";

export class UiLoginInfo extends MuWidget {
    isLogged(): boolean {
        return this.getState() == "logged";
    }
    
    formAccountEmail: string;
    
    beforeIndex(): void {
        this.muAppendContent(/*html*/`<button mu-id="userBtn" class="btn btn-outline-primary userBtn">
            <span class="material-symbols-outlined">account_circle</span>
            <span mu-bind="Name"></span>
            </button><span mu-id="userBlock" class="width-100p display-flex flex-items-grow-1">
            <strong mu-bind="stateText"></strong>
            <em mu-bind="Email"></em>
            
            <span class="flex-grow-0">
                <span class="btn btn-outline-primary" mu-id="bLogin">Přihlásit</span>
                <span class="btn btn-outline-primary" mu-id="bLogout">Odhlásit</span>
                <!-- <span class="btn btn-primary" mu-id="bReLogin">Znovu přihlásit</span> -->    
            </span>
            <div mu-bind="longInfo"></div>
        </span>`);
    }

    backend: CForms;

    vvzLogin: VVZLogin;

    afterIndex(): void {
        this.backend = (this.muParent as any).backend;
        this.vvzLogin = new VVZLogin();
        this.vvzLogin.backend = this.backend;
        this.refresh(true);
    }

    public getState(): "notMatch"|"logged"|"notLogged"
    {
        let state = "notLogged";
        let longInfo = "";
        if (this.vvzLogin.loginData.IsLogged) {
            if (this.formAccountEmail != this.vvzLogin.loginData.Email)
            {
                state = "notMatch";
            } else state = "logged";
        };

        return state;
    }

    async refresh(reload: boolean) {
        const stateToText = {
            notMatch: "Jiný účet",
            logged: "Přihlášen",
            notLogged: "Nepřihlášen",
        };
        const stateToCssClass = {
            notMatch: "danger",
            logged: "success",
            notLogged: "warning",
        };
        await this.vvzLogin.getLoginData();
        const state = this.getState();
        let longInfo = "";

        if (state == "notMatch") {
            longInfo = "Formulář je otevřen pro uživatele " + this.formAccountEmail 
                + " ale do věstníku jste přihlášen(a) jako " + this.vvzLogin.loginData.Email
                + ". Z toho důvodu není možné publikovat formulář. Odhlašte se a znovu přihlašte se znovu pod správným účtem tlačítkem výše."
        };

        this.muBindData({
            ...this.vvzLogin.loginData,
            state: state,
            stateText: stateToText[state],
            longInfo: longInfo
        });


        if (this.container.querySelector('[mu-bind="Name"]').textContent.length === 0) this.container.querySelector('[mu-bind="Name"]').textContent = "Nepřihlášen"
        if (state == "notMatch") {
            const warningEl: HTMLElement = document.createElement("span");
            warningEl.textContent = "warning";
            warningEl.style.fontSize = "24px";
            warningEl.style.paddingLeft = "4px";
            warningEl.style.verticalAlign = "middle";
            warningEl.classList.add("material-symbols-outlined");
            this.container.querySelector('[mu-bind="Name"]').appendChild(warningEl);
            this.container.querySelector('[mu-bind="Name"]').parentElement.classList.remove("btn-outline-primary");
            this.container.querySelector('[mu-bind="Name"]').parentElement.classList.add("btn-outline-warning");
            this.container.querySelector('[mu-bind="Name"]').appendChild(warningEl);
            this.container.querySelector('.userBtn > .material-symbols-outlined').textContent = "account_circle_off";
        } else {
            if (this.container.querySelector('[mu-bind="Name"] > .material-symbols-outlined') != null) this.container.querySelector('[mu-bind="Name"] > .material-symbols-outlined').remove();
            this.container.querySelector('[mu-bind="Name"]').parentElement.classList.remove("btn-outline-warning");
            this.container.querySelector('[mu-bind="Name"]').parentElement.classList.add("btn-outline-primary");
            this.container.querySelector('.userBtn > .material-symbols-outlined').textContent = "account_circle";
        }

        this.container.className = "alert alert-" + stateToCssClass[state];

        this.muVisible(state != "notLogged", "bLogout");
        this.muVisible(state == "notLogged", "bLogin");
        // this.muVisible(state == "notMatch", "bReLogin");

        return this.vvzLogin.loginData;
    }

    async bLogin_click() {
        return await this.doLogin();
    }

    userBtn_click() {
        if (this.ui.userBlock != null) this.ui.userBlock.classList.toggle("shown");
    }

    public async doLogin() {
        return await this.refresh(await this.vvzLogin.login());
    }

    async bReLogin_click() {
        await this.refresh(await this.vvzLogin.logout());
        return await this.refresh(await this.vvzLogin.login());
    }

    async bLogout_click() {
        return await this.refresh(await this.vvzLogin.logout());
    }

}

